import { PartnerName, ProductName } from '../types/interface/quote.interface'

export enum EnvType {
  ENV_LOCAL = 'local',
  ENV_TEST = 'test',
  ENV_DEV = 'development',
  ENV_ACC = 'acceptance',
  ENV_PROD = 'production',
}

export const ENV = process.env.ENV as EnvType

export const IS_LOCAL = ENV === EnvType.ENV_LOCAL
export const IS_DEVELOPMENT = ENV === EnvType.ENV_DEV
export const IS_ACCEPTANCE = ENV === EnvType.ENV_ACC
export const IS_PRODUCTION = ENV === EnvType.ENV_PROD

const ALL_BRANDS_TEST_GTM_ID = 'GTM-K89HQ3N'
const INSTABANK_PROD_GTM_ID = 'GTM-NZ339RM'
const INSTABANK_CONTENT_PROD_GTM_ID = 'GTM-THCKXWPP'
const NORD_PROD_GTM_ID = 'GTM-TNQM3CJC'
const NORD_TRAVEL_PROD_GTM_ID = 'GTM-5RGW4KPG'
const NORD_CONTENT_PROD_GTM_ID = 'GTM-N78NMHXH'
const INSTABANK_PROD_TRAVEL_GTM_ID = 'GTM-WX8ZQJ4'
const CIRCKEK_PROD_GTM_ID = 'GTM-5WVJNH2'
const COVERME_PROD_GTM_ID = 'GTM-MTD4X24V'

const GTM_CONFIG_MAP: Record<
  PartnerName,
  Record<string, Record<ProductName, Record<EnvType, string>>>
> = {
  [PartnerName.instabank]: {
    TRACKING_ID: {
      [ProductName.VEHICLE]: {
        [EnvType.ENV_LOCAL]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_TEST]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_DEV]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_ACC]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_PROD]: INSTABANK_PROD_GTM_ID,
      },
      [ProductName.TRAVEL]: {
        [EnvType.ENV_LOCAL]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_TEST]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_DEV]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_ACC]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_PROD]: INSTABANK_PROD_TRAVEL_GTM_ID,
      },
      [ProductName.CONTENT]: {
        [EnvType.ENV_LOCAL]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_TEST]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_DEV]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_ACC]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_PROD]: INSTABANK_CONTENT_PROD_GTM_ID,
      },
    },
  },
  [PartnerName.nord]: {
    TRACKING_ID: {
      [ProductName.VEHICLE]: {
        [EnvType.ENV_LOCAL]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_TEST]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_DEV]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_ACC]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_PROD]: NORD_PROD_GTM_ID,
      },
      [ProductName.TRAVEL]: {
        [EnvType.ENV_LOCAL]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_TEST]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_DEV]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_ACC]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_PROD]: NORD_TRAVEL_PROD_GTM_ID,
      },
      [ProductName.CONTENT]: {
        [EnvType.ENV_LOCAL]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_TEST]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_DEV]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_ACC]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_PROD]: NORD_CONTENT_PROD_GTM_ID,
      },
    },
  },
  [PartnerName.coverme]: {
    TRACKING_ID: {
      [ProductName.VEHICLE]: {
        [EnvType.ENV_LOCAL]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_TEST]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_DEV]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_ACC]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_PROD]: COVERME_PROD_GTM_ID,
      },
      [ProductName.TRAVEL]: {
        [EnvType.ENV_LOCAL]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_TEST]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_DEV]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_ACC]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_PROD]: COVERME_PROD_GTM_ID,
      },
      [ProductName.CONTENT]: {
        [EnvType.ENV_LOCAL]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_TEST]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_DEV]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_ACC]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_PROD]: COVERME_PROD_GTM_ID,
      },
    },
  },
  [PartnerName.circlek]: {
    TRACKING_ID: {
      [ProductName.VEHICLE]: {
        [EnvType.ENV_LOCAL]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_TEST]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_DEV]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_ACC]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_PROD]: CIRCKEK_PROD_GTM_ID,
      },
      [ProductName.TRAVEL]: {
        [EnvType.ENV_LOCAL]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_TEST]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_DEV]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_ACC]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_PROD]: CIRCKEK_PROD_GTM_ID,
      },
      [ProductName.CONTENT]: {
        [EnvType.ENV_LOCAL]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_TEST]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_DEV]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_ACC]: ALL_BRANDS_TEST_GTM_ID,
        [EnvType.ENV_PROD]: CIRCKEK_PROD_GTM_ID,
      },
    },
  },
}

// GTM Tracking per brand (partner)
const TRACKING_ID = GTM_CONFIG_MAP[PARTNER_NAME as PartnerName].TRACKING_ID

// Auth Portal host
const AUTH_PORTAL_LOCAL_HOST = 'https://auth.dev.dg-eleks.com'
const AUTH_PORTAL_DEV_HOST = 'https://auth.dev.dg-eleks.com'
const AUTH_PORTAL_ACC_HOST = 'https://auth.acc.dg-eleks.com'
const AUTH_PORTAL_PROD_HOST = 'https://auth.digisure.no'

const AUTH_PORTAL_HOST_MAP: Record<EnvType, string> = {
  [EnvType.ENV_LOCAL]: AUTH_PORTAL_LOCAL_HOST,
  [EnvType.ENV_TEST]: AUTH_PORTAL_LOCAL_HOST,
  [EnvType.ENV_DEV]: AUTH_PORTAL_DEV_HOST,
  [EnvType.ENV_ACC]: AUTH_PORTAL_ACC_HOST,
  [EnvType.ENV_PROD]: AUTH_PORTAL_PROD_HOST,
}

// Auth portal host per env
const AUTH_PORTAL_HOST = AUTH_PORTAL_HOST_MAP[ENV]

const AGENT_PORTAL_PROD_HOST = 'https://moller.digisure.no'
const AGENT_PORTAL_ACC_HOST = 'https://agent-portal.acc.dg-eleks.com'
const AGENT_PORTAL_DEV_HOST = 'https://agent-portal.dev.dg-eleks.com'
const AGENT_PORTAL_LOCAL_HOST = 'http://localhost:8081'

// Agent portal Nord
const AGENT_PORTAL_NORD_PROD_HOST = 'https://agent-nord.prod.dg-eleks.com' // TODO: Fix this with real PROD name
const AGENT_PORTAL_NORD_ACC_HOST = 'https://agent-nord.acc.dg-eleks.com'
const AGENT_PORTAL_NORD_DEV_HOST = 'https://agent-nord.dev.dg-eleks.com'
const AGENT_PORTAL_NORD_LOCAL_HOST = 'http://localhost:8081'

const AGENT_PORTAL_HOST_MAP: Record<PartnerName, Record<EnvType, string>> = {
  [PartnerName.instabank]: {
    [EnvType.ENV_LOCAL]: AGENT_PORTAL_LOCAL_HOST,
    [EnvType.ENV_TEST]: AGENT_PORTAL_LOCAL_HOST,
    [EnvType.ENV_DEV]: AGENT_PORTAL_DEV_HOST,
    [EnvType.ENV_ACC]: AGENT_PORTAL_ACC_HOST,
    [EnvType.ENV_PROD]: AGENT_PORTAL_PROD_HOST,
  },
  [PartnerName.circlek]: {
    [EnvType.ENV_LOCAL]: AGENT_PORTAL_LOCAL_HOST,
    [EnvType.ENV_TEST]: AGENT_PORTAL_LOCAL_HOST,
    [EnvType.ENV_DEV]: AGENT_PORTAL_DEV_HOST,
    [EnvType.ENV_ACC]: AGENT_PORTAL_ACC_HOST,
    [EnvType.ENV_PROD]: AGENT_PORTAL_PROD_HOST,
  },
  [PartnerName.nord]: {
    [EnvType.ENV_LOCAL]: AGENT_PORTAL_NORD_LOCAL_HOST,
    [EnvType.ENV_TEST]: AGENT_PORTAL_NORD_LOCAL_HOST,
    [EnvType.ENV_DEV]: AGENT_PORTAL_NORD_DEV_HOST,
    [EnvType.ENV_ACC]: AGENT_PORTAL_NORD_ACC_HOST,
    [EnvType.ENV_PROD]: AGENT_PORTAL_NORD_PROD_HOST,
  },
  [PartnerName.coverme]: {
    [EnvType.ENV_LOCAL]: AGENT_PORTAL_LOCAL_HOST,
    [EnvType.ENV_TEST]: AGENT_PORTAL_LOCAL_HOST,
    [EnvType.ENV_DEV]: AGENT_PORTAL_DEV_HOST,
    [EnvType.ENV_ACC]: AGENT_PORTAL_ACC_HOST,
    [EnvType.ENV_PROD]: AGENT_PORTAL_PROD_HOST,
  },
}

//agent portal host per env
const AGENT_PORTAL_HOST = AGENT_PORTAL_HOST_MAP[PARTNER_NAME as PartnerName][ENV]

export enum LanguageCode {
  SV = 'sv',
  NO = 'no',
}

export enum CountyCode {
  SE = 'se',
  NO = 'no',
}

const LANGUAGE_CODE_MAP: Record<PartnerName, LanguageCode> = {
  [PartnerName.instabank]: LanguageCode.NO,
  [PartnerName.nord]: LanguageCode.NO,
  [PartnerName.coverme]: LanguageCode.NO,
  [PartnerName.circlek]: LanguageCode.SV,
}

const CONFIG = {
  TRACKING_ID,
  AUTH_PORTAL_HOST,
  AGENT_PORTAL_HOST,
  LANGUAGE_CODE: LANGUAGE_CODE_MAP[PARTNER_NAME as PartnerName],
  RECAPTCHA_SITE_KEY: '6LfAHAoaAAAAADh2gDgJ4yu1RKe3u0A8-WsB0zi3',
  USER_INFO_KEY: 'ds-user-data',
  USER_INFO_KEY_BID: 'ds-user-data-bid',
  APOLLO_STORAGE_KEY: 'ds-storage',
  PRODUCT_ID_KEY: 'PID',
  SERVICE: {
    avtalegiro: {
      TEST: {
        NUMBER: '11110500019',
        URL: 'https://mtf.pvu.avtalegiro.no',
      },
      PRODUCTION: {
        NUMBER: '15063521903',
        URL: 'https://pvu.avtalegiro.no',
      },
    },
  },
  DEV_TOOLS: [true, 'true'].includes(process.env.DEV_TOOLS),
}

export enum FlowName {
  QUOTE_AND_BUY = 'qb',
  MY_PAGES = 'mypages',
}

export default CONFIG

export const SESSION_ID_KEY = 'session-id'
